<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>

    <slot></slot>

    <v-container>
      <v-row dense no-gutters>
        <v-col cols="12">
          <v-textarea
              v-model="message"
              :rows="4"
              :placeholder="$t('notifications.dialog.placeholder')"
              :rules="[v => v.trim().length > 0 || this.$t('notifications.dialog.empty') ]"
              class="t-compose-textarea"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-container>

    <v-card-actions>
      <v-btn text color="primary" class="t-compose-send-btn" @click="$emit('send', {text: message })">{{ $t('notifications.dialog.send') }}</v-btn>
      <v-spacer/>
      <v-btn color="secondary" text @click="$emit('close')" >{{ $t('notifications.dialog.dismiss') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DialogTemplate",
  data() {
    return {
      message: '',
      // this.$t('notifications.dialog.defaultMessage', {date: new Date().toLocaleString()}),
    };
  },
  props: {
    title: String,
  },
};
</script>
